// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.5.0';
export const APP_NAME = 'markwins';
export const FILE_HASH = '1780058543136';
export const BUILD_DATE = '2026-05-29T12:42:23.136Z';
/* tslint:enable */
